module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var type = [
    {name: 'None', value: 'none'},
    {name: 'Solid', value: 'solid'}];
var size = [1,2,3,5,7,9];
var corner = [0,2,4,6,8,10,15,20];

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Border</span></div>\r\n<div class=\"row prop-detail\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6 nopadding-r\">\r\n            <select name=\"borderStyle\" id=\"borderStyle\" >\r\n                ")
    ;  for (var i = 0; i < type.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(type[i].value))
    ; __append("\">")
    ; __append(escapeFn(type[i].name))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n            </select>\r\n        </div>\r\n\r\n        <div class=\"col-md-6 subsection nopadding\">\r\n            <div style=\"text-align: right;\">\r\n                <label class=\"prop-sublabel\" style=\"float: inherit; margin-right: 14px;\">Size</label> \r\n                <select name=\"borderSize\" id=\"borderSize\" >\r\n                    ")
    ;  for (var i = 0; i < size.length; i++) { 
    ; __append("\r\n                        <option value=\"")
    ; __append(escapeFn(size[i]))
    ; __append("\">")
    ; __append(escapeFn(size[i]))
    ; __append("</option>\r\n                    ")
    ;  }; 
    ; __append("\r\n                </select>\r\n                px\r\n            </div>\r\n        </div> \r\n       \r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6\">\r\n            <input type=\"color\" id=\"borderColorPicker\" name=\"borderColor\" value=\"")
    ; __append(escapeFn(borderColor))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input type=\"text\" id=\"borderColor\" name=\"borderColor\" maxlength=\"7\" class=\"color-picker-text\"  id=\"borderColorText\" value=\"")
    ; __append(escapeFn(borderColor))
    ; __append("\" />\r\n        </div>\r\n\r\n        <div class=\"col-md-6 subsection nopadding\">\r\n            <div style=\"text-align: right; margin-right: 14px;\">\r\n                <label class=\"prop-sublabel label-30\" style=\"float: inherit; margin-right: 5px;\">Radius</label>\r\n                <select name=\"cornerRadius\" id=\"cornerRadius\" >\r\n                    ")
    ;  for (var i = 0; i < corner.length; i++) { 
    ; __append("\r\n                        <option value=\"")
    ; __append(escapeFn(corner[i]))
    ; __append("\">")
    ; __append(escapeFn(corner[i]))
    ; __append("</option>\r\n                    ")
    ;  }; 
    ; __append("\r\n                </select>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}